var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 309,
    viewBox: "0 0 186 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.065 307.867C304.676 288.952 300.97 284.833 286.154 265.425C282.524 260.67 276.812 251.426 271.357 240.008C269.722 236.591 268.24 233.203 266.881 229.863C257.187 205.955 255.818 179.172 258.071 152.721C263.82 85.2322 227.289 24.3202 171.978 6.56294C116.571 -11.2228 55.0451 18.0373 25.0232 63.6976C21.1172 69.6388 3.88719 97.6746 1.34022 128.434C-6.72835 225.554 87.3479 264.362 230.491 293.745C233.276 294.315 246.533 296.488 249.346 296.877L328.074 307.877L328.065 307.867Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector22);
export default __webpack_public_path__ + "static/media/vector2-2.48b5f1fda32eea874e2ca7944cfafdf5.svg";
export { ForwardRef as ReactComponent };